module.exports = __webpack_public_path__ + "static/qs-8f2c15baf97d32fc03864c21a5f142c4.png";